import access from './access'
import ticket from './ticket'
import users from './users'
import { OrderLog, OrderOverview } from 'projects/flow-gui-access/views/orders'
import { Search } from 'projects/flow-gui-access/views/search'
import { Soon, AccessExport, ServiceExport, BillingExport } from 'projects/flow-gui-access/views/core'
import { About } from 'views/core'

var routes = [].concat(
  [
    {
      path: '/soon',
      exact: true,
      component: Soon
    }, {
      path: '/export/services',
      exact: true,
      component: ServiceExport
    }, {
      path: '/export/access',
      exact: true,
      component: AccessExport
    }, {
      path: '/export/billing/:id',
      exact: true,
      component: BillingExport
    }, {
      path: '/events',
      exact: true,
      component: OrderLog
    }, {
      path: '/search',
      exact: true,
      component: Search
    }, {
      path: '/orders',
      exact: true,
      component: OrderOverview
    }, {
      path: '/about',
      exact: true,
      component: About
    }
  ],
  access,
  ticket,
  users
)
module.exports = routes



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/routes/index.js